module.exports = __webpack_public_path__ + "static/icons/icon-chevron-circle-right-0390092ba7b953e9b602aa7945719416.svg";